import { Alert, Button, DeleteIcon, Space } from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  useConfirm,
} from "melco-shared-logic";
import { getNodePath } from "../../helper/downloadHelper";
import { useDeleteDownloadSingleFile } from "../../hooks/downloads/useDeleteDownloadSingleFile";
import { useCallback } from "react";

type DeleteDownloadSingleFilesProps<T> = {
  // selectedRowKeys: Key[];
  //setSelectedRowKeys: (keys: Key[]) => void;
  refetch?: () => void;
  data?: T[];
  row: any;
  treeData: any;
  appSettingsResponse: any;
  //  parentNodeOfDelete: any;
  //  selectedPathsToDelete: any[]
};

export const DeleteDownloadSingleFile: React.FC<
  DeleteDownloadSingleFilesProps<any>
> = ({ appSettingsResponse, treeData, row, refetch, data }) => {
  const { t } = useTranslation();
  const deleteDownloadFile = useDeleteDownloadSingleFile(appSettingsResponse);
  //const showWarningForRowKeys = useShowWarningForRowKeys(selectedRowKeys, data);
  let selectedPathToDelete = "";

  useCallback(() => { }, [])

  const confirmDelete = useConfirm(
    async () => {

      selectedPathToDelete = getNodePath(row, treeData)
      console.log(selectedPathToDelete);


      await deleteDownloadFile(
        selectedPathToDelete
      );


      if (refetch) {
        console.log("Refetch")
        refetch();
      }


    },
    {
      translationPrefix: "downloadfiles.actions.delete",
      // translationOptions: {
      //   count: selectedRowKeys.length,
      // },
      content: (
        <Space direction="vertical" size="small">
          {t("downloadfiles.actions.delete.confirmation.message")}

          <Alert
            type="warning"
            withBackground
            description={t("downloadfiles.actions.delete.confirmation.warning", {
              //   count: showWarningForRowKeys.length,
            })}
            showIcon={false}
          />
        </Space>
      ),
    }
  );


  return (
    <Button
      key="single-delete"
      onClick={() => {

        confirmDelete();
      }}
    >


      <DeleteIcon />

      {/* {t("downloadfiles.actions.delete.button")} */}
    </Button>
  );
};
